import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import s from './CalendarGrid.module.css';

/**
 * AB#1749 — Loading skeleton sized to roughly match the real grid so
 * the transition into data doesn't shift the layout dramatically.
 *
 * O1 (AB#2199, SO-43) — the old shimmer was white at 4% opacity, invisible on
 * the light theme, so the calendar looked blank for seconds. The skeleton now
 * draws a token-coloured header + staff columns and says what is loading
 * (role="status", announced to screen readers).
 */
const CalendarSkeleton: React.FC = () => {
    const { t } = useLanguage();
    return (
        <div
            className={`${s.gridRoot} ${s.skeleton}`}
            role="status"
            aria-live="polite"
            data-testid="calendar-skeleton"
        >
            <div className={s.skeletonHeader} aria-hidden="true">
                <span className={s.skeletonTimeCol} />
                {[0, 1, 2, 3].map(i => (
                    <span key={i} className={s.skeletonHeadCell}>
                        <span className={s.skeletonAvatar} />
                        <span className={s.skeletonLine} />
                    </span>
                ))}
            </div>
            <div className={s.skeletonBody} aria-hidden="true">
                <span className={s.skeletonTimeCol} />
                {[0, 1, 2, 3].map(i => (
                    <span key={i} className={s.skeletonCol}>
                        <span className={s.skeletonBlock} style={{ top: `${40 + i * 30}px`, height: '64px' }} />
                        <span className={s.skeletonBlock} style={{ top: `${220 + i * 20}px`, height: '44px' }} />
                    </span>
                ))}
            </div>
            <span className={s.skeletonLabel}>{t('calendar.loading')}</span>
        </div>
    );
};

export default CalendarSkeleton;
